export const QUERY = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;
